<div class="target-list-item" data-cy="element-target-list-item">
  <div class="line" *ngIf="account&&!isDryMode">
    <span class="name" data-name="account-data">{{account.description || "no description"}}</span>
  </div>
  <button mat-icon-button class="button-account-menu" *ngIf="!isDryMode" (click)="openDeleteShareDialog()">
    <mat-icon>delete</mat-icon>
  </button>
  <div class="logo"></div>

  <div class="attribute">
    <span>Attributes:</span>
    <table class="attributes-prices">
      <tr>
        <td>Segment Id</td>
        <td>Name</td>
        <td>Cpm</td>
        <td></td>
      </tr>
      <tr *ngFor="let attributePrice of attributePrices">
        <td>{{attributePrice.segmentId}}</td>
        <td>{{attributePrice.attributeName}}</td>
        <td>{{attributePrice.cpmInCent === null ? 'n.a.' : '€' + (attributePrice.cpmInCent / 100 | number : '1.2-2')}}</td>
        <td>
          <button *ngIf="isDryMode" mat-button name="add-to-attribute" (click)="dryDrop(attributePrice)">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>
        </td>
      </tr>
    </table>
    <div class="new-attribute-price">
      <form (ngSubmit)="createAttributePrice()" #attributePriceForm="ngForm">

        <mat-form-field class="attribute field">
          <mat-label>Attribute Name</mat-label>
          <mat-select [(ngModel)]="newActiveAgentAttributeId" name="attribute" required="true">
            <mat-option *ngFor="let attribute of attributes" [value]="attribute.id">
              {{attribute.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="currency field">
          <mat-label>Price (EU)</mat-label>
          <input [disabled]="!isBillable()" type="number" matInput step="0.01" min="0.01" [(ngModel)]="newCpmInCent"
                 name="price"/>
          <span matSuffix>&nbsp;EU</span>
        </mat-form-field>

        <section class="add field">
          <button
            [disabled]="!attributePriceForm.form.valid
              || sendingCreate
              || (isDryMode && newActiveAgentAttributeId && !hasDuplicate(newActiveAgentAttributeId))"
            color="accent"
            mat-raised-button
            name="add-to-attribute"
            type="submit">
            <mat-icon>add</mat-icon>
          </button>
        </section>
      </form>

    </div>
    <div *ngIf="createError" class="error error-request">
      <span>Failed: {{createError?.error["message"] || createError?.message}}</span>
    </div>
  </div>
</div>
